/**
 * @module services/service-record
 * @description Servicio HTTP para el registro unificado de transacciones prestacionales
 */
import api from "./api";

export default {
  /** @param {Object} params - searchInput, origin, billingMonth, billingYear, offset, limit */
  get: (params) => api.get("/service-records", { params }).then((r) => r.data),
  /** @param {string} id */
  getById: (id) => api.get(`/service-records/${id}`).then((r) => r.data),
};
